import { render, staticRenderFns } from "./ConsumerMessage.vue?vue&type=template&id=c0276246&"
import script from "./ConsumerMessage.vue?vue&type=script&lang=js&"
export * from "./ConsumerMessage.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerMessage.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports